<div>
  <div class="bg-card flex w-full flex-0 flex-col overflow-hidden shadow dark:bg-black dark:bg-opacity-10 my-4"
    *ngFor="let post of items">
    <div class="flex justify-between p-4">
      <div class="items-center">

        <!-- START USER CONTROL -->
        <app-drake-user [userCode]="post[userIdField]?.value"></app-drake-user>
        <!-- END USER CONTROL -->
      </div>
      <div class="ml-4 mt-3 min-w-0">
        <div class="text-sm"> {{post[dateField] | date:'dd/MM/yyyy HH:mm'}}</div>
      </div>
    </div>
    <div class="mx-4 mb-2 flex whitespace-pre-line leading-relaxed">
      {{post[messageField]}}
    </div>
    <div class="mx-4 mb-4 flex whitespace-pre-line leading-relaxed border rounded border-slate-200 p-4" *ngIf="post[mediaField].id">
      <app-drake-file-preview [fileId]="post[mediaField].id"></app-drake-file-preview>
    </div>
    <div class="mx-4 mb-4  text-right">
      <mat-icon class="mx-1">thumb_up</mat-icon>
      <mat-icon class="mx-1">share</mat-icon>
    </div>
  </div>
</div>